<template>
  <footer class="footer flex flex-col xl:flex-row p-4 text-xs xl:items-end gap-8 leading-tight">
    <div class="flex gap-2 lg:gap-4 items-start md:items-end max-w-max-width flex-col md:flex-row">
      <img src="../../../images/logos/ep.svg" alt="European Parliament" class="h-8" />
      With the financial support of the European Parliament. Sole liability rests with the author.
      The European Parliament is not responsible for any use that may be made
      of the information contained therein.
    </div>
    <div class="flex flex-col lg:flex-row xl:ms-auto gap-1 lg:gap-2">
      <strong class="shrink-0">European Greens</strong>
      <address class="not-italic truncate">Rue du Taciturne 34 B-1000 Brussels, Belgium</address>
      <a href="tel:003226260720" class="underline hover:text-green-pine shrink-0">+32 (0) 2 626 07 20</a>
      <a href="mailto:congress@europeangreens.eu" class="underline hover:text-green-pine shrink-0">congress@europeangreens.eu</a>
      <a href="https://europeangreens.eu/privacy-policy/" class="underline hover:text-green-pine shrink-0">Privacy Policy</a>
    </div>
  </footer>
</template>